import { useMemo } from 'react';
import { SupportedEntitlements } from '../core/models/entitlements';
import { useOrganization } from './queries/useOrganization';

export const useEntitlements = (): Map<string, string> => {
  const { organization } = useOrganization();

  const entitlements = useMemo(() => {
    if (organization?.entitlements) {
      if (import.meta.env.MODE === 'development' || organization.entitlements.has('developer')) {
        const allSupporteEntitlements = Object.values(SupportedEntitlements);

        return allSupporteEntitlements.reduce((acc, entitlement) => {
          return acc.set(entitlement, entitlement);
        }, new Map());
      }

      return organization.entitlements;
    }

    return new Map();
  }, [organization]);

  return entitlements;
};
